module.exports = __webpack_public_path__ + "static/media/get_started_3.3b94cddb.png";